import { render, staticRenderFns } from "./flow_footer.vue?vue&type=template&id=6d7a01ad&scoped=true&"
import script from "./flow_footer.vue?vue&type=script&lang=js&"
export * from "./flow_footer.vue?vue&type=script&lang=js&"
import style0 from "./flow_footer.vue?vue&type=style&index=0&id=6d7a01ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a01ad",
  null
  
)

export default component.exports